/**
 * Strictly non-negative alternative to the native remainder (%) operator.
 * @param {number} n
 * @param {number} m
 * @returns {number} The result of n modulo m, always non-negative.
 */
export default function (n, m) {
  return ((n % m) + m) % m
}
